import { render, staticRenderFns } from "./hamburger.vue?vue&type=template&id=2b95acc6&scoped=true&"
import script from "./hamburger.vue?vue&type=script&lang=js&"
export * from "./hamburger.vue?vue&type=script&lang=js&"
import style0 from "./hamburger.vue?vue&type=style&index=0&id=2b95acc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95acc6",
  null
  
)

export default component.exports